module.exports = "/_next/static/images/original-ffb516098ca144da31b7c701975c23fb.png";